<template>
  <scheduled-event-form />
</template>

<script>
import ScheduledEventForm from 'VueComponents/ScheduledEventForm';

export default {
  components: {
    ScheduledEventForm,
  },
};
</script>
